/**
 * A popup appearing under the Header's search input, encouraging users to search.
 * Rendered by the InterruptionChooser via a portal
 * Cadence determined by HeaderSearchPopup Dismissible.
 * Triggers a header_search_popup impression.
 */

import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import styled from 'astroturf/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';

import { ImpressionWatcher } from 'js/utils/impressions';
import { useOnClickOutside } from 'js/utils/hooks';
import _Container from "SearchPopup-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/SearchBar/SearchPopup.tsx?styleId=Container";
import _styles from "SearchPopup-styles.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/SearchBar/SearchPopup.tsx?styleId=styles";


const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
});

const styles = _styles;

// TODO: css transition fade in/out
const SearchPopup = () => {
  const containerRef = useRef<HTMLDivElement>();

  const [show, setShow] = useState(true);
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'MutableRefObject<HTMLDivElement ... Remove this comment to see the full error message
  useOnClickOutside(containerRef, () => setShow(false));

  useEffect(() => {
    window.Aedu.Dismissibles.recordShow('HeaderSearchPopup');
    return;
  }, []);

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'SiteStats' does not exist on type 'typeo... Remove this comment to see the full error message
  const numMillionWorks = window.Aedu.SiteStats.paper_count_in_millions;

  return (
    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    <Container show={show} ref={containerRef}>
      <ImpressionWatcher
        className={styles.watcher}
        source="header_search_popup"
      >
        Search {numMillionWorks} million papers on Academia
        <FontAwesomeIcon
          icon={faTimes}
          onClick={() => {
            setShow(false);
            window.Aedu.Dismissibles.recordDismissal('HeaderSearchPopup');
          }}
          style={{
            color: '#ADADAD',
            fontSize: 16,
            marginLeft: 32,
            cursor: 'pointer',
            opacity: 0.5,
          }}
        />
      </ImpressionWatcher>
    </Container>
  );
};

const SearchPopupPortal = () => {
  const searchInputPopupRoot = document.getElementById('nav--search-input');
  if (searchInputPopupRoot != null) {
    return ReactDOM.createPortal(<SearchPopup />, searchInputPopupRoot);
  }
  return null;
};

export default SearchPopupPortal;
